module.exports = __webpack_public_path__ + "img/setting.71ce0f3d.svg";